<p-toast key="assignerEntretien"></p-toast>

<p-blockUI [blocked]="blocked">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-blockUI>


<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div #contenu *ngIf="EstCharge()">

	<div class="fluid formgrid grid">
		<div class="col-12 md:col-9 lg:col-6 mb-3">
			<p-selectButton [options]="types" [(ngModel)]="selectionType" optionLabel="valeur">
			</p-selectButton>
		</div>

	</div>

	<div *ngIf="selectionType.cle == 'E'" class="fluid formgrid grid">
		<div class="col-12">
			<p-table #dt [value]="bonsTravail" dataKey="bonTravailId" autoLayout="true" tableStyleClass="tableNormale"
				styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" [filterDelay]="0"
				[globalFilterFields]="['numero','date','item.numero','item.description','mecanicien.nom','mecanicien.prenom','mecanicien.prenomNom','mecanicien.initiales','mecanicien.recherche','contreMaitre.nom','contreMaitre.prenom','contreMaitre.prenomNom','contreMaitre.initiales','contreMaitre.recherche']">
				<ng-template pTemplate="caption">
					<div class="flex align-content-center justify-content-between">
						<div>
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
									placeholder="Recherche..." />
							</span>
						</div>
						<h5 class="titreTableau m-0">Bons de travail</h5>
						<div>
							<p-multiSelect disabled="true" [style]="{minWidth: '200px'}" placeholder="Colonnes...">
							</p-multiSelect>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header" let-columns>
					<tr>
						<th pSortableColumn="numero">
							<div class="flex justify-content-between align-items-center">
								Numéro
								<p-sortIcon field="numero"></p-sortIcon>
								<p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="dateDebut">
							<div class="flex justify-content-between align-items-center">
								Date
								<p-sortIcon field="dateDebut"></p-sortIcon>
								<p-columnFilter type="date" field="dateDebut" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="item.numero">
							<div class="flex justify-content-between align-items-center">
								Unité
								<p-sortIcon field="item.numero"></p-sortIcon>
								<p-columnFilter type="text" field="item.numero" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="item.description">
							<div class="flex justify-content-between align-items-center">
								Description
								<p-sortIcon field="item.description"></p-sortIcon>
								<p-columnFilter type="text" field="item.description" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th>
							<div class="flex justify-content-between align-items-center">
								Heures / KM
							</div>
						</th>
						<th pSortableColumn="type">
							<div class="flex justify-content-between align-items-center">
								Statut
								<p-sortIcon field="type"></p-sortIcon>
								<p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
									[showOperator]="false" [showAddButton]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
											(onChange)="filter($event.value)" optionLabel="name">
											<ng-template let-option pTemplate="item">
												<div class="multiselect-representative-option">

													<span class="ml-1">{{option.nom}}</span>
												</div>
											</ng-template>
										</p-multiSelect>
									</ng-template>
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="contreMaitre.prenom">
							<div class="flex justify-content-between align-items-center">
								Contre-Maître
								<p-sortIcon field="contreMaitre.prenom"></p-sortIcon>
								<p-columnFilter type="text" field="contreMaitre.recherche" display="menu"
									class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="mecanicien.prenom">
							<div class="flex justify-content-between align-items-center">
								Mécanicien
								<p-sortIcon field="mecanicien.prenom"></p-sortIcon>
								<p-columnFilter type="text" field="mecanicien.recherche" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th style="min-width: 7rem; width: 7rem;"></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-bdt let-columns="columns">
					<tr>
						<td>{{bdt.numero}}</td>
						<td>{{bdt.dateTravail | date:'yyyy-MM-dd'}}</td>
						<td>{{bdt.item.numero}}</td>
						<td>{{bdt.item.description}}</td>
						<td>
							<app-ecart-releve-bt
								[heuresDebut]="bdt.heuresDebutCompteur"
								[heuresFin]="bdt.heuresCompteur"
								[kmDebut]="bdt.kmDebutCompteur"
								[kmFin]="bdt.kmCompteur"></app-ecart-releve-bt>
						</td>
						<td><span [class]="'statut ' + bdt.statut.nom.toLowerCase().replace(' ', '')">
								{{bdt.statut.nom}}
							</span></td>
						<td><app-employe-avec-emplacement [employe]="bdt.contreMaitre"></app-employe-avec-emplacement></td>
						<td><app-employe-avec-emplacement [employe]="bdt.mecanicien"></app-employe-avec-emplacement></td>
						<td class="celluleTableau">
							<div class="flex">
								<button *ngIf="estAutorise('temp_mec')" pButton pRipple icon="pi pi-check"
									class="p-button-success mr-2 boutonGrille"
									(click)="selectionnerBonTravail(bdt)"></button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="9">Aucun bon de travail.</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

	</div>

	@if (selectionType.cle == 'N') {
		<p-card styleClass="ajout-bon-travail-card">
			<div class="flex flex-column md:flex-row md:align-items-center gap-2 mb-4">
				<h5 class="mb-0">Soumission de bon de travail</h5>
				<span class="statut nouveau">Nouveau</span>
			</div>

			<div class="fluid formgrid grid">
				<div class="sihc-field flex flex-column gap-2 col-12 mb-3">
					<label for="typeBonTravail">Type</label>
					<p-selectButton
						inputId="typeBonTravail"
						styleClass="type-bon-travail-select w-full md:w-auto"
						[options]="typesBonTravail"
						[(ngModel)]="selectionTypeBonTravail"
						optionLabel="valeur" />
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 mb-3">
					<label for="uniteSelectionnee">Unité</label>
					<app-affichage-unite-item [item]="bonTravail.item" [editable]="false" />
					@if (dernierBonTravailRecent) {
						<p-message severity="warn" styleClass="w-full mt-2" [text]="texteDernierBonTravailRecent"></p-message>
					}
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="dateBonTravail">Date<span class="requis">*</span></label>
					<p-calendar
						inputId="dateBonTravail"
						appendTo="body"
						showIcon="true"
						[(ngModel)]="bonTravail.dateTravail"
						dateFormat="yy-mm-dd"
						[yearNavigator]="true"
						[monthNavigator]="true"
						yearRange="2000:2040" />
					@if (submitted && !bonTravail.dateTravail) {
						<small class="p-error">La date est obligatoire.</small>
					}
				</div>
				<div class="hidden md:block md:col-6 mb-3" aria-hidden="true"></div>

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="raisonBonTravail">Raison<span class="requis">*</span></label>
					<p-dropdown
						inputId="raisonBonTravail"
						[options]="raisons"
						[(ngModel)]="bonTravail.raison"
						optionLabel="description"
						[showClear]="true"
						filter="true"
						filterBy="code,description"
						appendTo="body"
						placeholder="Sélectionner une raison…">
						<ng-template pTemplate="selectedItem">
							@if (bonTravail.raison) {
								<div class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ bonTravail.raison.code | valeurVide }}</span>
									<span class="text-sm">{{ bonTravail.raison.description | valeurVide }}</span>
								</div>
							}
						</ng-template>
						<ng-template let-raison pTemplate="item">
							<div class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ raison.code | valeurVide }}</span>
								<span class="text-sm text-color-secondary">{{ raison.description | valeurVide }}</span>
							</div>
						</ng-template>
					</p-dropdown>
					@if (submitted && !bonTravail.raison) {
						<small class="p-error">La raison est obligatoire.</small>
					}
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="contreMaitreBonTravail">Contre-maître<span class="requis">*</span></label>
					<p-dropdown
						inputId="contreMaitreBonTravail"
						[options]="listeEmployes"
						[(ngModel)]="bonTravail.contreMaitre"
						optionLabel="nom"
						[showClear]="true"
						filter="true"
						filterBy="prenomNom,prenom,nom,noEmploye,initiales"
						appendTo="body"
						placeholder="Sélectionner un contre-maître…">
						<ng-template pTemplate="selectedItem">
							@if (bonTravail.contreMaitre) {
								<div class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ bonTravail.contreMaitre.noEmploye | valeurVide }}</span>
									<span class="text-sm">{{ bonTravail.contreMaitre.prenom }} {{ bonTravail.contreMaitre.nom }}</span>
								</div>
							}
						</ng-template>
						<ng-template let-employe pTemplate="item">
							<div class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ employe.noEmploye | valeurVide }}</span>
								<span class="text-sm text-color-secondary">{{ employe.prenom }} {{ employe.nom }}</span>
							</div>
						</ng-template>
					</p-dropdown>
					@if (submitted && !bonTravail.contreMaitre) {
						<small class="p-error">Le contre-maître est obligatoire.</small>
					}
				</div>

				@if (selectionTypeBonTravail.cle == 1) {
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<label for="mecanicienBonTravail">Mécanicien</label>
						<p-dropdown
							inputId="mecanicienBonTravail"
							[options]="listeEmployes"
							[(ngModel)]="bonTravail.mecanicien"
							optionLabel="nom"
							[showClear]="true"
							filter="true"
							filterBy="prenomNom,prenom,nom,noEmploye,initiales"
							appendTo="body"
							placeholder="Sélectionner un mécanicien…">
							<ng-template pTemplate="selectedItem">
								@if (bonTravail.mecanicien) {
									<div class="flex flex-column gap-1 py-1">
										<span class="font-bold">{{ bonTravail.mecanicien.noEmploye | valeurVide }}</span>
										<span class="text-sm">{{ bonTravail.mecanicien.prenom }} {{ bonTravail.mecanicien.nom }}</span>
									</div>
								}
							</ng-template>
							<ng-template let-employe pTemplate="item">
								<div class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ employe.noEmploye | valeurVide }}</span>
									<span class="text-sm text-color-secondary">{{ employe.prenom }} {{ employe.nom }}</span>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				}

				@if (selectionTypeBonTravail.cle == 2) {
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<label for="fournisseurBonTravail">Fournisseur</label>
						<p-dropdown
							inputId="fournisseurBonTravail"
							[options]="fournisseurs"
							[(ngModel)]="bonTravail.fournisseur"
							optionLabel="nom"
							[showClear]="true"
							filter="true"
							filterBy="numero,nom"
							appendTo="body"
							placeholder="Sélectionner un fournisseur…">
							<ng-template pTemplate="selectedItem">
								@if (bonTravail.fournisseur) {
									<div class="flex flex-column gap-1 py-1">
										<span class="font-bold">{{ bonTravail.fournisseur.numero | valeurVide }}</span>
										<span class="text-sm">{{ bonTravail.fournisseur.nom | valeurVide }}</span>
									</div>
								}
							</ng-template>
							<ng-template let-fournisseur pTemplate="item">
								<div class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ fournisseur.numero | valeurVide }}</span>
									<span class="text-sm text-color-secondary">{{ fournisseur.nom | valeurVide }}</span>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				}

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="emplacementBonTravail">Emplacement</label>
					<p-dropdown
						inputId="emplacementBonTravail"
						[options]="emplacements"
						[(ngModel)]="bonTravail.emplacement"
						optionLabel="nom"
						[showClear]="true"
						filter="true"
						filterBy="code,nom"
						appendTo="body"
						placeholder="Sélectionner un emplacement…">
						<ng-template pTemplate="selectedItem">
							@if (bonTravail.emplacement) {
								<div class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ bonTravail.emplacement.code | valeurVide }}</span>
									<span class="text-sm">{{ bonTravail.emplacement.nom | valeurVide }}</span>
								</div>
							}
						</ng-template>
						<ng-template let-emplacement pTemplate="item">
							<div class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ emplacement.code | valeurVide }}</span>
								<span class="text-sm text-color-secondary">{{ emplacement.nom | valeurVide }}</span>
							</div>
						</ng-template>
					</p-dropdown>
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 mb-3">
					<label for="noteBonTravail">Note</label>
					<textarea
						id="noteBonTravail"
						pInputTextarea
						[rows]="4"
						[(ngModel)]="bonTravail.note"
						autocomplete="off"
						placeholder="Ajouter une note…"
						class="w-full"></textarea>
				</div>

				@if (bonTravail.item?.itemId) {
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<app-releve-bt-selector
							[itemId]="bonTravail.item.itemId"
							type="heure"
							cote="debut"
							[(valeur)]="bonTravail.heuresDebutCompteur"
							[placeholder]="bonTravail.item.heuresCompteur"
							[releveLie]="bonTravail.releveHeureDebut"
							(releveLieChange)="surReleveDebutHeureChange($any($event))" />
					</div>
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<app-releve-bt-selector
							[itemId]="bonTravail.item.itemId"
							type="km"
							cote="debut"
							[(valeur)]="bonTravail.kmDebutCompteur"
							[placeholder]="bonTravail.item.kmCompteur"
							[releveLie]="bonTravail.releveKmDebut"
							(releveLieChange)="surReleveDebutKmChange($any($event))" />
					</div>
				}
			</div>
		</p-card>

		<div class="flex justify-content-end gap-2 mt-3">
			<p-button label="Annuler" icon="pi pi-ban" [text]="true" (onClick)="annuler()" />
			<p-button label="Créer le bon de travail" icon="pi pi-save" [loading]="creationEnCours" (onClick)="assigner()" />
		</div>
	}

</div>